import { Settings } from "../../core/services/configService";
import { CrudService } from "../../core/services/crudService";
import { CustomerHelper } from "../../crm/helpers/customerHelper";

export const AsNeededSlot = "A";

// The customer's treatment: what is due today, the whole treatment, and marking takes. Days travel as yyyy-MM-dd.
export class TreatmentApi {
  static base(): string {
    return `${Settings.HostName}/api/publiccustomertreatments/customer/${CustomerHelper.getStoredCustomer()}`;
  }

  static today(): Promise<any> {
    return new CrudService().httpGet(`${this.base()}/today`);
  }

  static detail(): Promise<any> {
    return new CrudService().httpGet(this.base());
  }

  // Active lines with no moment, no time and not "as needed": nothing to mark, but shown so the patient does not miss them.
  static unscheduled(lines: any[]): any[] {
    return lines
      .filter((l: any) => l.state === "active" && !l.slots.length && !l.asNeeded)
      .map((l: any) => ({ treatmentId: l.id, name: l.name, dose: l.dose, brand: l.brand, note: l.note, taken: false }));
  }

  // `shown`: the lines on screen with their version; the server refuses the mark if any of them changed meanwhile.
  static markSlot(slot: string, date: string, shown: { treatmentId: number; version: string }[]): Promise<any> {
    return new CrudService().httpPost(`${this.base()}/takes`, { slot: slot, date: date || null, shown: shown });
  }

  static undoOperation(operationId: string): Promise<any> {
    return new CrudService().httpDelete(`${this.base()}/takes/ops/${operationId}`);
  }

  static markLine(treatmentId: number, slot: string, date: string, version: string): Promise<any> {
    return new CrudService().httpPost(`${this.base()}/lines/${treatmentId}/takes`, { slot: slot, date: date || null, shown: [{ treatmentId: treatmentId, version: version }] });
  }

  static undoLine(treatmentId: number, slot: string, date: string): Promise<any> {
    return new CrudService().httpDelete(`${this.base()}/lines/${treatmentId}/takes?date=${date}&slot=${encodeURIComponent(slot)}`);
  }
}
